"use client";

import * as React from "react";
import { DirectionProvider as RadixDirectionProvider } from "@radix-ui/react-direction";

/**
 * Radix primitives (Tabs, Select, DropdownMenu, …) don't read the `<html dir>`
 * attribute — without this they default to `ltr` and stamp `dir="ltr"` on
 * their own root, which silently flips everything rendered inside a tab
 * (forms, tables) back to LTR on an otherwise RTL page.
 */
export function DirectionProvider({
  dir = "rtl",
  children,
}: {
  dir?: "rtl" | "ltr";
  children: React.ReactNode;
}) {
  return <RadixDirectionProvider dir={dir}>{children}</RadixDirectionProvider>;
}
